import { Divider, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { Modal, SummaryTable } from 'src/ui'
import * as S from './styles'
import useProfile from './Profile.State'

const Profile: React.FC = () => {
  const { user, wallets, blockchainIdx, showQR, closeQR } = useProfile()

  return (
    <>
      <S.Flex mt="24px" mb="48px">
        <Box>
          <Box sx={{ width: '500px' }}>
            <Typography variant="subtitle2" color="grey.500">
              Profile
            </Typography>
            <Divider sx={{ marginBottom: '24px' }} />
            <SummaryTable
              data={[
                {
                  key: <Typography fontWeight={500}>Company Name</Typography>,
                  value: <Typography>{user?.organization_name || 'N/A'}</Typography>
                },
                {
                  key: <Typography fontWeight={500}>Organization ID</Typography>,
                  value: <Typography>{user?.organization_id || 'N/A'}</Typography>
                },
                {
                  key: <Typography fontWeight={500}>Email</Typography>,
                  value: <Typography>{user?.email || 'N/A'}</Typography>
                }
              ]}
            />
          </Box>
        </Box>
      </S.Flex>
      {wallets[blockchainIdx] && (
        <Modal open={showQR} onClose={closeQR} title={`${wallets[blockchainIdx].name} address`} keepMounted>
          <Divider />
          <Box display="flex" alignItems="center" flexDirection="column">
            {wallets[blockchainIdx].address && <S.CustomQRCode value={wallets[blockchainIdx].address} size={200} />}
            <Typography>{wallets[blockchainIdx].address}</Typography>
          </Box>
        </Modal>
      )}
    </>
  )
}

export default Profile
